import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { bimContractDefaultsGql } from '../BimContractRequests';

export const useBimContractDefaults = (projectUniqueId?: string, contractId?: number) => {
    const getContractVariables = useMemo(
        () =>
            projectUniqueId
                ? {
                      projectUniqueId,
                  }
                : undefined,
        [projectUniqueId],
    );

    const requestId = useMemo(() => `bimContractDefaults${projectUniqueId}`, [projectUniqueId]);

    const [bimContractDefaultsData, bimContractDefaultsStatus] = useRequest({
        requestId,
        query: bimContractDefaultsGql,
        withEffect: !contractId && !!projectUniqueId,
        variables: getContractVariables,
    });

    const data = useMemo(() => bimContractDefaultsData?.bimContractDefaults.data, [bimContractDefaultsData]);

    const [bimContractDefaultsMakeReset] = useResetStoreData({ requestId });

    return {
        bimContractDefaultsData: data,
        bimContractDefaultsStatus,
        bimContractDefaultsMakeReset,
    };
};
